import {registerNode, Rect} from '@topology/core'
import { IFrame } from './iFrame'
export function register() {
  registerNode('IFrame', IFrame, null, function (node) {
    node.iconRect = new Rect(node.rect.x, node.rect.y, node.rect.width, node.rect.height)
    node.fullIconRect = node.rect
  }, null)
}
// # sourceMappingURL=register.js.map



// WEBPACK FOOTER //
// ./src/components/topologyDiagram/iFrame/register.js